import React, { Component, Fragment } from 'react';
import { BreadCrumb, Card, Modal } from '../../components';
import { Translate } from '../../contexts/Language';
import { DataTableColumns } from '../../config/DataTableColumns';
import DataTable from 'react-data-table-component';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage } from '../../components/Validator';
import DataTableExtensions from 'react-data-table-component-extensions';


export class CustomerDocuments extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataTable: {
                columns: DataTableColumns.documentList,
                rows: []
            },
            documentDataTable: {
                columns: DataTableColumns.documentTable,
                rows: [],
            },
            modal: false,
            customerLogin: 0,
            detail: {
                files: [],
                file: null
            },
            validation: {
                error: false,
                message: ""
            }
        }

        this.onDetail = this.onDetail.bind(this);
    }
    componentDidMount() {
        this.onDatatable();
    }
    onDatatable() {
        Config.utilities.loadingFetch();

        Service.DocumentService.List().then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable,
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onDetail(login) {

        Config.utilities.loadingFetch();

        Service.DocumentService.Detail({ login }).then(response => {

            if (response) {
                this.setState(prevState => ({
                    detail: response,
                    modal: true,
                    customerLogin: login,
                    documentDataTable: {
                        ...prevState.documentDataTable,
                        rows: response.files,
                    }

                }));
            }
            Config.utilities.loadingFetch();
        });
    }
    onAction(status) {
        Config.utilities.loadingFetch();

        Service.DocumentService.Action({ 'login': this.state.customerLogin, 'approve': status }).then(response => {

            if (response) {
                if (response.error) {
                    this.setState({
                        validation: response
                    });
                }
                else {
                    this.setState({
                        modal: false,
                        customerLogin: 0
                    });
                    this.onDatatable();
                }


            }
            Config.utilities.loadingFetch();
        });
    }



    render() {
        const { documentDataTable } = this.state;
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Customer Documents")} Name={Translate("Customer Documents")} />
                <Card Title="Customer Documents" Description="Customer uploaded images.">
                    <Modal Title={Translate("Customer Images")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                        <div className="row mt-1 mb-1">
                            <div className="col-md-12">
                                <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                    <ErrorMessage Validation={this.state.validation} />
                                    <DataTable
                                        columns={documentDataTable.columns}
                                        data={documentDataTable.rows}
                                        noHeader={true}
                                        pagination
                                        highlightOnHover />
                                    <div className="form-group row ml-1 mr-1">
                                        <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                        <div className="col-sm-8">
                                            <button type="button" className="btn btn-danger float-right" onClick={(e) => this.onAction(false)}><i className="far fa-save mr-1"></i> Reject</button>
                                            <button type="button" className="btn btn-success float-right mr-2" onClick={(e) => this.onAction(true)}><i className="far fa-save mr-1"></i> Approve</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal>
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTableExtensions columns={this.state.dataTable.columns(this.onDetail)} data={this.state.dataTable.rows} exportHeaders={false}>
                                    <DataTable
                                        noHeader={true}
                                        pagination
                                        highlightOnHover />
                                </DataTableExtensions>)}
                        </div>
                    </div>
                </Card>
            </Fragment>)
    }
}